"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../base/config");
var meta_1 = require("../base/meta");
function logger(data, level) {
    if (level === void 0) { level = 'info'; }
    var methodBlackList = ['getUserInfo', 'getDriverInfo', 'getDeviceMarkInfo', 'getSystemInfo', 'getPosition', 'getHydraData', 'getLocationInfo', 'requestLogin', 'callNativeBizLogin', 'callNativeLoginWithCallback', 'callNativeLogin'];
    var logData;
    var method = data.method || '';
    if (methodBlackList.includes(method)) {
        logData = {
            params: "This bridge callback data cannot be reported. (" + JSON.stringify(methodBlackList) + ")"
        };
    }
    else {
        logData = {
            meta: __assign({}, meta_1.default),
            level: level,
            logData: data
        };
    }
    if (process.env.NODE_ENV !== 'production' && !config_1.default.silent) {
        console[level]("%c " + level.toUpperCase() + " %c WEBVIEW_UTIL %c", 'background:#272d32 ; padding: 1px; border-radius: 2px 0 0 2px;  color: #fff', 'background-image: linear-gradient(to bottom right, #2F86F6, #2F86F6, #2F86F6) ; padding: 1px; border-radius: 0 2px 2px 0;  color: #fff', 'background:transparent', logData);
        return;
    }
    if (config_1.default.autoTrack && window.Omega && window.Omega.trackEvent) {
        if (level === 'error') {
            window.Omega.trackError('tech_mfe_webview_util', '', logData);
        }
        else {
            window.Omega.trackEvent('tech_mfe_webview_util', '', logData);
        }
    }
    var raven;
    if (config_1.default.autoTrack && window.$raven) {
        raven = raven || new window.$raven({ key: '@didi/mfe_webview_util' });
        if (level === 'error') {
            raven.trackError('tech_mfe_webview_util', logData);
        }
        else {
            raven.trackEvent('tech_mfe_webview_util', { mfe_webview_util_params: logData });
        }
    }
}
exports.logger = logger;
function errorer(msg) {
    logger({ params: msg }, 'error');
}
exports.errorer = errorer;
